import { useQuery } from '@tanstack/react-query';
import { supabase } from '../../shared/api/supabase';
import { listHolidays } from './api';

export const holidayKeys = { all: ['business-holidays'] as const };

/** One cached query for the whole session: the list does not change while someone is ordering. */
export const useHolidays = (enabled = true) =>
  useQuery({
    queryKey: holidayKeys.all,
    queryFn: () => listHolidays(supabase),
    enabled,
    staleTime: Number.POSITIVE_INFINITY,
    gcTime: Number.POSITIVE_INFINITY,
  });
